export const orderPluralMapping = {
  '=0': 'No Orders',
  '=1': '1 Order',
  other: '# Orders',
};
